import { INTERACTION_ACTIONS, PoliciesDataType } from 'domain/shared/compliance';

export const isRegistryItemNew = (compliance: PoliciesDataType): boolean => {
  const isSignatureRequired = compliance?.isSignatureRequired;
  return !isSignatureRequired && !isComplianceRegistryItemViewed(compliance);
};

export const isComplianceRegistryItemNotSigned = (compliance: PoliciesDataType) => {
  const isSignatureRequired = compliance?.isSignatureRequired;
  return isSignatureRequired && compliance?.isPolicyAccepted === null;
};

export const isComplianceRegistryItemViewed = (compliance: PoliciesDataType & { isViewed?: boolean }) =>
  (compliance?.isViewed ||
    compliance?.interactionTimeline?.some(
      item => item?.action === INTERACTION_ACTIONS.VIEWED && item?.policyPath === compliance?.policyPath,
    )) ??
  false;

export const getComplianceRegistryPortalPriority = (compliance: PoliciesDataType & { isViewed?: boolean }) => {
  if (isComplianceRegistryItemNotSigned(compliance)) return 0;
  if (isRegistryItemNew(compliance)) return 1;
  return 2;
};

export const sortComplianceRegistryItemsForPortal = <T extends PoliciesDataType & { isViewed?: boolean }>(
  policies: T[],
): T[] =>
  [...policies].sort((left, right) => {
    const priorityDiff = getComplianceRegistryPortalPriority(left) - getComplianceRegistryPortalPriority(right);

    if (priorityDiff !== 0) return priorityDiff;

    return new Date(right.policyCreatedAt).getTime() - new Date(left.policyCreatedAt).getTime();
  });
